import {
  CREATE_MODULE,
  DELETE_MODULE,
  FETCH_MODULE,
  FETCH_MODULES,
  FETCH_MODULES_FOR_SELECTOR,
  MODULE_ERROR,
  MODULE_SELECTOR_LOADING,
  SEARCH_MODULES,
  CLEAR_MODULE_SEARCH,
  UPDATE_MODULE,
} from "../actions/types";

const initialState = {
  modules: { data: [], pagination: null },
  singleModule: {
    name: "",
    description: "",
    videos: [],
  },
  moduleError: null,
  moduleMessage: null,
  // Module selector specific state
  selectorModules: [],
  selectorPagination: null,
  selectorSearchResults: [],
  selectorLoading: false,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATE_MODULE:
      return {
        ...state,
        singleModule: action.payload,
      };
    case UPDATE_MODULE:
      return {
        ...state,
        singleModule: action.payload,
      };
    case MODULE_ERROR:
      return {
        ...state,
        moduleError: action.payload,
      };
    case FETCH_MODULES:
      console.log('FETCH_MODULES reducer - action.payload:', action.payload);
      return {
        ...state,
        modules: action.payload,
      };
    case FETCH_MODULE:
      return {
        ...state,
        singleModule: action.payload,
      };
    case DELETE_MODULE:
      return {
        ...state,
        singleModule: action.payload,
      };
    case FETCH_MODULES_FOR_SELECTOR:
      const newModules = action.payload.data || [];
      const shouldAppend = action.payload.append;
      
      return {
        ...state,
        selectorModules: shouldAppend 
          ? [...state.selectorModules, ...newModules]
          : newModules,
        selectorPagination: action.payload.pagination || null,
      };
    case SEARCH_MODULES:
      const newSearchModules = action.payload.data || [];
      const shouldAppendSearch = action.payload.append;
      
      return {
        ...state,
        selectorSearchResults: shouldAppendSearch 
          ? [...state.selectorSearchResults, ...newSearchModules]
          : newSearchModules,
        selectorPagination: action.payload.pagination || null,
      };
    case CLEAR_MODULE_SEARCH:
      return {
        ...state,
        selectorSearchResults: [],
      };
    case MODULE_SELECTOR_LOADING:
      return {
        ...state,
        selectorLoading: action.payload,
      };
    default:
      return state;
  }
}
